export const CLOSE_EVENT_ACTION = 'cancel';
export const RESTORE_EVENT_ACTION = 'restore';

export type ButtonEventAction = typeof CLOSE_EVENT_ACTION | typeof RESTORE_EVENT_ACTION;
